exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading-wrapper[data-v-1a6551c7]{position:relative\n}\n.loading-wrapper>.content-container.hide[data-v-1a6551c7]{opacity:.5;pointer-events:none\n}\n.loading-wrapper>.spinner-container[data-v-1a6551c7]{position:absolute;top:0;bottom:0;left:0;right:0;display:grid;place-items:center\n}", ""]);

// exports
